<template>
  <div class="visa-materials-anchor" v-if="showAnchor">
    <div
      class="anchor-attr"
      v-for="attrItem in currMaterial"
      :key="attrItem.attr"
    >
      <div
        class="anchor-attr-body"
        :class="{active: activeAnchor === `attr-${attrItem.attr}`}"
        @click="scrollToSection(`.attr-list-title-${attrItem.attr}`)"
      >{{attrItem.name}}({{attrItem.materialTotal}})</div>
      <div class="anchor-classify-list">
        <div
          class="anchor-classify-item"
          :class="{active: activeAnchor === `classify-${attrItem.attr}-${classifyItem.catalog_id}`}"
          v-for="classifyItem in attrItem.classifyList"
          :key="classifyItem.catalog_id"
          @click="scrollToSection(`.classify-item-${attrItem.attr}-${classifyItem.catalog_id}`)"
        >
          {{classifyItem.name}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/libs/utils';

export default {
  components: {},
  props: {
    currMaterial: Array,
  },
  data() {
    return {
      headerHeight: 144, // 头部高度 68 + 16 + 60
      showAnchor: false,
      activeAnchor: '',
    };
  },
  computed: {
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      try {
        const headerHeight = this.headerHeight;
        const visaMaterialsEl = document.querySelector('#visa-materials');
        const visaMaterialsElRect = visaMaterialsEl.getBoundingClientRect();
        const pageBodyHeight = window.innerHeight;
        if (visaMaterialsElRect.top < headerHeight && visaMaterialsElRect.top + visaMaterialsElRect.height > pageBodyHeight) {
          this.showAnchor = true;
        } else {
          this.showAnchor = false;
        }

        // 本质上就是从上往下找，然后找到最后一个锚点元素top小于0的，也就是当前激活的。
        let activeAnchor = `attr-${this.currMaterial[0].attr}`;

        for (let index = 0; index < this.currMaterial.length; index++) {
          const attrItem = this.currMaterial[index];
          const attrEl = visaMaterialsEl.querySelector(`.attr-list-title-${attrItem.attr}`);
          const attrElRect = attrEl.getBoundingClientRect();
          if (attrElRect.top < headerHeight) {
            activeAnchor = `attr-${attrItem.attr}`;
          } else {
            break;
          }

          for (let j = 0; j < attrItem.classifyList.length; j++) {
            const classifyItem = attrItem.classifyList[j];
            const classifyEl = visaMaterialsEl.querySelector(`.classify-item-${attrItem.attr}-${classifyItem.catalog_id}`);
            const classifyElRect = classifyEl.getBoundingClientRect();
            if (classifyElRect.top < headerHeight) {
              activeAnchor = `classify-${attrItem.attr}-${classifyItem.catalog_id}`;
            } else {
              break;
            }
          }
        }

        this.activeAnchor = activeAnchor;
      } catch (error) {
        //
        console.log(error);
      }
    },

    // 滚动到评价模块
    scrollToSection(id) {
      utils.scrollToElement(id, this.headerHeight - 1);
    },
  },
};
</script>

<style lang="less" scoped>
@media (max-width: 1400px) {
  .visa-materials-anchor {
    display: none !important;
  }
}
.visa-materials-anchor{
  position: fixed;
  top: calc(~'50% + 34px');
  transform: translateY(-50%);
 
  // 让浮窗位置固定在离主体内容区右侧外面 20px 的位置
  right: calc(~'50% + 560px + 20px');
  z-index: 10;
  max-height: 80%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1;
  .anchor-attr{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-bottom: 16px;
    &:last-child{
      margin-bottom: 0;
    }
    .anchor-attr-body{
      cursor: pointer;
      padding: 0 12px;
      height: 32px;
      display: flex;
      align-items: center;
      color: #2F333D;
      font-size: 14px;
      font-weight: 600;
      background: #FAFBFC;
      border-radius: 16px;
      border: 1px solid #E9EEF2;

      &.active{
        background: #DDEBFF;
        color: #599FFF;
        border: 1px solid #DDEBFF;
      }
    }
    .anchor-classify-list{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin-top: 8px;
      .anchor-classify-item{
        cursor: pointer;
        margin-bottom: 8px;
        padding: 0 12px;
        height: 32px;
        display: flex;
        align-items: center;
        color: #2F333D;
        font-size: 14px;
        background: #FAFBFC;
        border-radius: 16px;
        border: 1px solid #E9EEF2;
        &:last-child{
          margin-bottom: 0;
        }
        &.active{
          background: #DDEBFF;
          color: #599FFF;
          border: 1px solid #DDEBFF;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/visa-materials-anchor.vue